import React, { useState, useEffect } from "react";
import axios from "axios";
import { trackLead } from "../pages/metaPixel";
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import CategorySection from '../components/landingpage/InquiryCategories';
import { Modal, Button } from "react-bootstrap";
import VideoModal from '../components/VideoModal';



const GetQuoteForm = ({ inquiry = false }) => {
  const [sheet, setSheet] = useState([
    {
      id: 1,
      name: "",
      qty: "",
      quantity: "",
      piece: "Pieces",
      price: 0,
      des: "",
      status: "normal",
      cat: ""
    }
  ]);
  const navigate = useNavigate();
  const [uid, setUid] = useState();
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [userData, setUserData] = useState(null);
  const [alert1, setAlert1] = useState();
  const [searchTerm, setSearchTerm] = useState("");
  const [error, seterror] = useState(false);
  const [cat, setCat] = useState("");
  const [main, setMainCat] = useState([]);
  const [showCategoryDropdown, setShowCategoryDropdown] = useState(false);
  const [manualCategorySelected, setManualCategorySelected] = useState(false);
  const [autoCategoryTried, setAutoCategoryTried] = useState(false);
  const [showCategoryModal, setShowCategoryModal] = useState(false);

  const getMainCat = async () => {
    const data = new FormData();
    data.append("uid", "ss");
    if(!inquiry) data.append("status", "enable");
    axios({
      method: "post",
      url: "/pro/cat/maincat.php",
      data: data,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((s) => {
        const a = s.data;
        setMainCat(Array.isArray(a) ? a : []);
      })
      .catch(() => setMainCat([]));
  };

  const [videoToOpen, setVideoToOpen] = useState(null);

  const videos = [
    {
      id: 'getQuote',
      title: 'Get Quote Tutorial',
      url: 'https://www.youtube.com/embed/GgyPHm-x27c',
    }
  ];

  const add_lead = async (sheet, uid, c) => {
    const data = new FormData();
    data.append("uid", uid);
    data.append("sheet", JSON.stringify(sheet));
    data.append("cat", c);
    data.append("img", "");

    if (inquiry) {
      data.append("status", "inquiry");
    }

    const leadItem = sheet?.[0] || {};
    const leadDetails = {
      quote_type: 'general',
      content_name: leadItem?.name || "Unknown Product",
      value: parseFloat(leadItem?.price) || 0,
      currency: "PKR",
      content_category: c || "General",
      quantity: leadItem?.qty || 1
    };

    const res = await axios.post("/pro/lead_add.php", data, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    if (!inquiry) trackLead(leadDetails);

    // const insert_id = res?.data?.[0]?.insert_id;

    // if (inquiry && insert_id) {
    //   await axios.post("/pro/lead_inquiry.php", {
    //     uid,
    //     leadsheet_id: insert_id,
    //     name: userData?.name || name,
    //     phone: userData?.phone || phone,
    //   });
    // }

    setAlert1(!alert1);
    if (!inquiry) {
      window.location.href = "/product-buy-request";
    }
    else {
      alert('Inquiry submitted successfully! Our team will get back to you as soon as possible.');
      window.location.href = "/";
    }
  };

  const changeArayquote = (i, changes) => {
    const oldArr = [...sheet];
    const oldObj = oldArr[i];
    oldArr[i] = { ...oldObj, ...changes };
    setSheet(oldArr);

    if (changes.name !== undefined) {
      setManualCategorySelected(false);
      setShowCategoryDropdown(false);
      setAutoCategoryTried(false);
      setCat("");
    }

    const validationErrors = { ...error };

    Object.keys(changes).forEach((key) => {
      if (inquiry) {
        if (key === "fullname" && !changes.fullname) validationErrors.fullname = "Error: Full Name is required.";
        else if (key === "fullname") delete validationErrors.fullname;

        if (key === "phone" && !changes.phone) validationErrors.phone = "Error: Valid Phone Number is required.";

        else if (key === "phone" && !changes.phone) validationErrors.phone = "Error: Valid Phone Number is required.";

        else if (key === "phone" && changes.phone.length < 10){
          validationErrors.phone = "Invalid phone number. It must be exactly 10 digits long, e.g., 3001234567.";
        }
        else if (key === "phone") delete validationErrors.phone;
      }
      if (key === "name" && !changes.name) validationErrors.name = "Error: Name of Product is required.";
      else if (key === "name") delete validationErrors.name;

      if (key === "qty" && (!changes.qty || Number(changes.qty) < 1)) validationErrors.qty = "Error: Quantity must be greater than 0.";
      else if (key === "qty") delete validationErrors.qty;

      if (key === "piece" && !changes.piece) validationErrors.piece = "Error: Please select a valid unit.";
      else if (key === "piece") delete validationErrors.piece;

      // if (key === "price" && (!changes.price || Number(changes.price) < 1)) validationErrors.price = "Error: Approx Price must be greater than 0.";
      // else if (key === "price") delete validationErrors.price;

      if (key === "des" && !changes.des) validationErrors.des = "Error: Requirement Description is required.";
      else if (key === "des") delete validationErrors.des;
    });

    seterror(validationErrors);
  };

  useEffect(() => {
    getMainCat();
    const aa = localStorage.getItem("USER");
    if (aa != null) {
      const as = JSON.parse(aa);
      setUid(as[0].id);
      setUserData(as[0]);
    }
  }, []);

  const filteredCategories = Array.isArray(main)
    ? main.filter((category) =>
        category.title?.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : [];

  const handleSubmit = async () => {
    if (!uid && !inquiry) return window.location.href = "/login";

    const validationErrors = {};
    if (!sheet[0].name) validationErrors.name = "Error: Name of Product is required.";
    if (!sheet[0].qty || Number(sheet[0].qty) < 1) validationErrors.qty = "Error: Quantity must be greater than 0.";
    if (!sheet[0].piece) validationErrors.piece = "Error: Please select a valid unit.";
    // if (!sheet[0].price || Number(sheet[0].price) < 1) validationErrors.price = "Error: Approx Price must be greater than 0.";
    
    if (inquiry && !userData) {
      if (!name) validationErrors.fullname = "Error: Full Name is required.";
      if (!phone) validationErrors.phone = "Error: Valid Phone Number is required.";

      else if (phone.length < 10){
        validationErrors.phone = "Invalid phone number. It must be exactly 10 digits long, e.g., 3001234567.";
      }
    }

    if (Object.keys(validationErrors).length > 0) {
      seterror(validationErrors);
      return;
    }

    if (!manualCategorySelected && !autoCategoryTried) {
      try {
        const data = {
          product_name: sheet[0].name,
          uid: uid,
          alahdeen: true,
          only_parent: true
        };
        
        if (!inquiry) {
          data.status = "enable";
        }
        
        const categoryResponse = await axios.post('/pro/openai/generate_product_categories.php', data);        

        setAutoCategoryTried(true);

        if (categoryResponse.data && categoryResponse.data.hierarchy.length > 0) {
          const autoCatId = categoryResponse.data.hierarchy[0].id;
          setCat(autoCatId);
          add_lead(sheet, uid, autoCatId);
        } else {
          setShowCategoryModal(true);
        }
      } catch (e) {
        setShowCategoryModal(true); 
      }
    } else if (manualCategorySelected && cat) {
      add_lead(sheet, uid, cat);
    } else if (!cat) {
      seterror((prev) => ({ ...prev, category: "Error: Category is required." }));
    }
  };

  return (
    <div className="mb-0 d-flex flex-column flex-grow-1" style={{ boxShadow: '0px 0px 6px 2px #ccc', borderRadius: '16px', background: '#fff', height: '100%', marginLeft: '5px', marginRight: '5px' }}>
      <div className="mt-2 px-3 d-flex flex-column flex-grow-1">
        <h4 className="main-heading-style color-gray-900 text-center mb-0 mt-3">{inquiry ? 'Inquiry Form' : 'Get Quote' }</h4>
        <div className=" row mb-2">
        <div className="mb-3">
        
        <Button style={{
          backgroundColor: 'rgb(0, 140, 153)',
                                color: 'whitesmoke',
                                border: '1px solid #008C99',
                                fontSize: '16px',
                                fontWeight: 500
                              }} onClick={() => setVideoToOpen('getQuote')} className="p-1 btn btn-xs mb-1 btn-block">
          Get Quote Tutorial – Click to Watch
        </Button>
        </div>
        </div>

        {inquiry && !userData && (
          <>
   <div className="mb-3">
                <input
                type="text"
                className={`form-control rounded mb-1`}
                placeholder="Enter Full Name"
                maxLength={30}
                value={name}
                onChange={(e) => {
                  changeArayquote(0, { fullname: e.target.value });
                  setName(e.target.value);
                }}
                style={{ borderColor: error?.fullname ? "red" : undefined }}
              />
              {error?.fullname && <span className="text-danger small d-block">{error.fullname}</span>}
              </div>
              <div className="mb-3">
<div className="input-group rounded  mb-1">
  <div className="input-group-prepend">
    <span className="input-group-text">+92</span>
  </div>
  <input
    type="text"
    className={`form-control`}
    placeholder="Phone No."
    value={phone}
    onChange={(e) => {
      let newValue = e.target.value.replace(/[.-]/g, "");
      if (newValue.charAt(0) === "0") newValue = "";
      if (newValue.length <= 10) setPhone(newValue);
      changeArayquote(0, { phone: e.target.value });
    }}
    style={{ borderColor: error?.phone ? "red" : undefined }}
  />
</div>
{error?.phone && <span className="text-danger small d-block">{error.phone}</span>}
</div>
          </>
        )}
   <div className={`mb-3`}>
<input style={{ borderColor: error?.name ? "red" : "transparent", color: "black" }} className={`form-control border rounded mb-1`} placeholder="Name of Product" type="text" value={sheet[0].name} onChange={(e) => changeArayquote(0, { name: e.target.value })} />
{error?.name && <span className="text-danger small d-block">{error.name}</span>}
</div>
<div className="mb-3">
        <input type="number" style={{ borderColor: error?.qty ? "red" : "transparent", color: "black" }} className={`form-control border rounded mb-1`} placeholder="Quantity" value={sheet[0].qty} onChange={(e) => changeArayquote(0, { qty: e.target.value, quantity: e.target.value })} />
        {error?.qty && <span className="text-danger small d-block">{error.qty}</span>}
        </div>
        {/* <div className="mb-3">
        <input type="number" style={{ borderColor: error?.price ? "red" : "transparent", color: "black" }} className={`form-control border rounded mb-1`} placeholder="Approx Price Rs" value={sheet[0].price} onChange={(e) => changeArayquote(0, { price: e.target.value })} />
        {error?.price && <span className="text-danger small d-block">{error.price}</span>}
        </div> */}
        
        <select style={{ borderColor: error?.piece ? "red" : "transparent" }} value={sheet[0].piece} onChange={(e) => changeArayquote(0, { piece: e.target.value })} className="py-3 px-2 border rounded" aria-label="Select option">
          <option>Units</option>
          <option>Pieces</option>
          <option>Grams</option>
          <option>Kilograms</option>
          <option>Tons</option>
          <option>Litres</option>
        </select>
        {error?.piece && <span className="text-danger small d-block">{error.piece}</span>}
        
        {showCategoryDropdown && (
          <div className="mt-2">
            <div className="dropdown">
              <button className="btn dropdown-toggle form-control border" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false" style={{ ...(error?.category ? { borderColor: "#FA8072", color: "#FA8072", backgroundColor: '#4f97a1' } : { backgroundColor: '#4f97a1', color: 'white' }) }}>
                {error?.category ? error?.category : cat ? main.find((v) => v.id === cat)?.title || "Select Main Category" : "Select Main Category"}
              </button>
              <ul className="dropdown-menu form-control border" aria-labelledby="dropdownMenuButton" style={{ maxHeight: filteredCategories.length > 0 ? `${Math.min(filteredCategories.length * 50 + 50, 300)}px` : "50px", overflowY: "auto", height: "auto", width: "100%" }}>
                <li>
                  <input type="text" className="form-control mb-2" placeholder="Search Category" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                </li>
                {filteredCategories.map((v) => (
                  <li key={v.id}>
                    <button className="dropdown-item" onClick={() => {
                      setCat(v.id);
                      setManualCategorySelected(true);
                      changeArayquote(0, { category: v.id });
                      seterror((prev) => {
                        const updated = { ...prev };
                        delete updated.category;
                        return updated;
                      });
                    }}>
                      {v.title}
                    </button>
                  </li>
                ))}
                {!inquiry && (
                  <>
                    <li><hr className="dropdown-divider" /></li>
                    <li key="inquiry-link">
                      <button
                        className="dropdown-item"
                        onClick={() => {
                          window.location.href = '/inquiry';
                        }}
                      >
                        Didn't find? Submit an inquiry
                      </button>
                    </li>
                  </>
                )}

                {inquiry && (
                  <>
                    <li><hr className="dropdown-divider" /></li>
                    <li key="inquiry-link">
                      <button
                        className="dropdown-item"
                        onClick={() => {
                          window.open("https://api.whatsapp.com/send?phone=923242229339", "_blank");
                        }}
                      >
                        Didn't find? Talk to us on WhatsApp
                      </button>
                    </li>
                  </>
                )}




              </ul>
            </div>
          </div>
        )}
<div className="mb-3">
        <textarea className={`form-control border rounded mt-3 flex-grow-1`} style={{ borderColor: error?.des ? "red" : "transparent", color: "black" }} placeholder="Requirement Description" maxLength={100} value={sheet[0].des} onChange={(e) => changeArayquote(0, { des: e.target.value })}></textarea>
        {error?.des && <span className="text-danger small d-block">{error.des}</span>}
        </div>
        
      </div>

      <div className="row">
        <div className="form-group text-center">
          <button onClick={handleSubmit} className="btn" style={{ backgroundColor: "#45ACB3", color: "white", marginTop: "20px", boxShadow: "3px 3px 10px 6px #ccc", border: "1px solid #45ACB3 !important" }}>
            {inquiry ? 'Submit Your Inquiry' : 'Get Quote' }
          </button>
        </div>
      </div>

      
      {showCategoryModal && (
  inquiry ? (
    // 🟩 Simple modal for inquiry === true
    <div className="modal show d-block" tabIndex="-1">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header modal-title-style">
            <h5 className="modal-title">Category Not Found</h5>
            <button type="button" className="btn-close" onClick={() => {
                setShowCategoryModal(false);
                setShowCategoryDropdown(true);
                seterror((prev) => ({ ...prev, category: "Error: Category is required." }));
              }}></button>
          </div>
          <div className="modal-body">
            We couldn’t identify your product category automatically. You can select a category manually or talk to us on WhatsApp.
          </div>
          <div className="modal-footer">
            <a
              href="https://api.whatsapp.com/send?phone=923242229339"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-success"
            >
              Talk to us on WhatsApp
            </a>
            <button
              className="btn btn-primary"
              onClick={() => {
                setShowCategoryModal(false);
                setShowCategoryDropdown(true);
                seterror((prev) => ({ ...prev, category: "Error: Category is required." }));
              }}
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  ) : (
    // 🟥 More detailed modal for inquiry !== true
    <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header modal-title-style">
            <h5 className="modal-title">Unsupported Product Category</h5>
            <button type="button" className="btn-close" onClick={() => {
                setShowCategoryModal(false);
                setShowCategoryDropdown(true);
                seterror((prev) => ({ ...prev, category: "Error: Category is required." }));
              }}></button>
          </div>
          <div className="modal-body">
            We couldn't match your product category.<br/>
            It's possible we do not currently support this category.<br/>
            Please select one of the supported categories below or submit a general inquiry.
            <CategorySection inquiry={inquiry} setCat={setCat} setShowCategoryModal={setShowCategoryModal} setShowCategoryDropdown={setShowCategoryDropdown} setManualCategorySelected={setManualCategorySelected}/>
          </div>
          <div className="modal-footer">
            <button
              className="btn btn-secondary"
              onClick={() => {
                setShowCategoryModal(false);
                setShowCategoryDropdown(true);
                seterror((prev) => ({ ...prev, category: "Error: Category is required." }));
              }}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary"
              onClick={() => {
                window.location.href = "/inquiry";
              }}
            >
              Submit Inquiry
            </button>
          </div>
        </div>
      </div>
    </div>
  )
)}
      <VideoModal
        videoList={videos}
        videoIdToShow={videoToOpen}
        onClose={() => setVideoToOpen(null)}
      />
      </div>



  );
};

export default GetQuoteForm;
